import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedMaterialModule } from '../shared-material.module';

// ONLY FOR DEMO
// ALWAYS REQUIRED
import { ConfirmComponent } from '../services/app-confirm/confirm.component';

import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { FormsModule } from '@angular/forms';
import { FormModule } from '../../form/form.module';
import { MatCardModule } from '@angular/material/card';
import { ListComponent } from './list/list.component';
import { ListTextComponent } from './list/list-text.component';
import { MenuLayoutComponent } from './layouts/menu-layout/menu-layout.component';
import { ConfirmBottomComponent } from '../services/app-confirm/confirm-bottom.component';
import { SharedDirectivesModule } from '../directives/shared.directives.module';
import { IconButtonWhatsappComponent } from './icon-button-whatsapp/icon-button-whatsapp.component';
import { CustomSnackbarComponent } from './custom-snackbar/custom-snackbar.component';
import { SharedRecaptcha } from './shared-recaptcha/shared-recaptcha';
import { NgxCaptchaModule } from 'ngx-captcha';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { ButtonComponent, NavbarComponent } from '@marsaude/sira-components';

const components = [
  SharedRecaptcha,
  CustomSnackbarComponent,
  IconButtonWhatsappComponent,
  ListComponent,
  ListTextComponent,
  AuthLayoutComponent,
  ConfirmComponent,
  MenuLayoutComponent,
  ConfirmBottomComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormModule,
    RouterModule,
    SharedMaterialModule,
    FormsModule,
    MatCardModule,
    SharedDirectivesModule,
    NgxCaptchaModule,
    SharedPipesModule,
    ButtonComponent,
    NavbarComponent
  ],
  declarations: components,
  exports: [components, ButtonComponent]
})
export class SharedComponentsModule {
}
